export enum ConfigitAssignmentAuthor {
    User = 0,
    Constraint = 1,
    Procedure = 2,
    Default = 3,
    Environment = 4,
    None = 5,
}
